import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { AdminApi, AdminProductPrice } from 'api';
import useApiCall from 'hooks/use-api-call';
import Translate from 'ui/atoms/translate';
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalFooterButtons } from 'ui/molecules/modal';
import Date from 'src/ui/atoms/date';

interface DeleteMarketPriceModalProps {
  marketPrice: AdminProductPrice;
  onDeleteMarketPrice: () => void;
  onClose: () => void;
}

const DeleteMarketPriceModal: FunctionComponent<DeleteMarketPriceModalProps> = ({
  marketPrice,
  onDeleteMarketPrice,
  onClose,
}) => {
  const { makeAuthenticatedApi, withApi } = useApiCall();

  const api: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

  const onSubmit = useCallback(() => {
    withApi(async () => {
      await api.adminProductPricesDestroy({ id: marketPrice.id });

      onDeleteMarketPrice();
    });
  }, [api, marketPrice.id]);

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="marketPrices.deleteMarketPrice" />
      </ModalHeader>
      <ModalContent>
        <Translate
          name="marketPrices.deleteMarketPriceConfirmation"
          args={[<Date showTime>{marketPrice.priceAt}</Date>]}
        />
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'cancel',
              content: <Translate name="common.cancel" />,
              size: 'large',
              onClick: () => onClose(),
            },
            {
              name: 'delete',
              content: <Translate name="common.delete" />,
              onClick: () => onSubmit(),
              variant: 'primary',
              type: 'submit',
              size: 'large',
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteMarketPriceModal;
